var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiveStream(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.63281 8.57031C7.85156 9.35156 7.85156 10.6172 8.63281 11.4023C9.41406 12.1836 10.6797 12.1836 11.4648 11.4023C12.2461 10.6211 12.2461 9.35547 11.4648 8.57031C10.6797 7.78906 9.41406 7.78906 8.63281 8.57031Z",
    fill: "#8F8C9D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.293 5.73828C13.9023 5.34766 13.2695 5.34766 12.8789 5.73828C12.4883 6.12891 12.4883 6.76172 12.8789 7.15234C14.4375 8.71484 14.4375 11.2539 12.8789 12.8125C12.4883 13.2031 12.4883 13.8359 12.8789 14.2266C13.0742 14.4219 13.332 14.5195 13.5859 14.5195C13.8437 14.5195 14.0977 14.4219 14.293 14.2266C16.6328 11.8906 16.6328 8.08203 14.293 5.73828Z",
    fill: "#667085"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.21484 5.73828C6.82422 5.34766 6.19141 5.34766 5.80078 5.73828C4.66797 6.87109 4.04297 8.37891 4.04297 9.98438C4.04297 11.5898 4.66797 13.0977 5.80078 14.2305C5.99609 14.4258 6.25391 14.5234 6.50781 14.5234C6.76563 14.5234 7.01953 14.4258 7.21484 14.2305C7.60547 13.8398 7.60547 13.207 7.21484 12.8164C5.65234 11.2539 5.65234 8.71484 7.21484 7.15625C7.60938 6.76563 7.60938 6.13281 7.21484 5.73828Z",
    fill: "#667085"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1211 2.91016C16.7305 2.51953 16.0977 2.51953 15.707 2.91016C15.3164 3.30078 15.3164 3.93359 15.707 4.32422C18.8281 7.44531 18.8281 12.5234 15.707 15.6445C15.3164 16.0352 15.3164 16.668 15.707 17.0586C15.9023 17.2539 16.6016 17.6719 17.1211 17.0586C20.6797 12.8437 21.0234 6.8125 17.1211 2.91016Z",
    fill: "#667085"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.38669 4.32422C4.77732 3.93359 4.77732 3.30078 4.38669 2.91016C3.99607 2.51953 3.36326 2.51953 2.97263 2.91016C-0.929712 6.8125 -0.839868 13.0742 2.97263 17.0625C3.50779 17.625 4.19138 17.2578 4.38669 17.0625C4.77732 16.6719 4.77732 16.0391 4.38669 15.6484C1.2656 12.5234 1.2656 7.44531 4.38669 4.32422Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveStream);
export default __webpack_public_path__ + "static/media/live-stream.a2604b7a4540bbd8d5682b8f972af7a1.svg";
export { ForwardRef as ReactComponent };